import { render, staticRenderFns } from "./IconArrowUp.vue?vue&type=template&id=27299a58&"
import script from "./IconArrowUp.vue?vue&type=script&lang=js&"
export * from "./IconArrowUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports